import {Fragment} from "react";
import ExpertPaymentActionContainer from "./ExpertPaymentActionContainer";
import BasicModal from "../../common/BasicModal";

export default function ExpertPaymentActionModal({title, open, handleClose, handleClearState, selectedUserIds, actionType}) {

    return(
        <Fragment>
            <BasicModal
                title={title}
                open={open}
                style={{width: '500px'}}
                handleClose={handleClose}>

                <ExpertPaymentActionContainer
                    handleClose={handleClose}
                    handleClearState={handleClearState}
                    selectedUserIds={selectedUserIds}
                    actionType={actionType}
                />
            </BasicModal>
        </Fragment>
    )
}